<template>
  <div class="row">
    <div class="small-12 columns">
      <h1>Update Engineering Branch</h1>
      <div class="row">
        <div class="small-3 columns">Name</div>
        <div class="small-9 columns">
          <input v-model="name" type="text" class="input-box-course-creators" />
        </div>
      </div>
      <div class="row">
        <div class="small-12 columns">
          <button class="button-blue" @click="editEngineeringBranch">
            Update Engineering Branch
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      name: undefined,
    }
  },
  mounted() {
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}engbranch/${this.$route.params.id}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    }).then(res => {
      this.name = res.data.name
    })
  },
  methods: {
    editEngineeringBranch() {
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}engbranch/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { name: this.name },
      }).then(() => {
        this.$router.push("/engineering-branches/")
      })
    },
  },
}
</script>
